import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b6b469c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Skriv ut prislapper", -1))
const _hoisted_3 = { class: "price-tags-modal__size" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "printPriceTagsSize",
  class: "label"
}, "Størrelse", -1))
const _hoisted_5 = { class: "price-tags-modal__price" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "printPriceTagsPrice",
  class: "label"
}, "Pris", -1))
const _hoisted_7 = {
  key: 0,
  class: "price-tags-modal__custom-text"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "printPriceTagsCustomText",
  class: "label"
}, "Ekstra tekst", -1))
const _hoisted_9 = { class: "price-tags-modal__buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_TextButton = _resolveComponent("TextButton")!
  const _component_ValidationFormErrors = _resolveComponent("ValidationFormErrors")!
  const _component_ButtonGroup = _resolveComponent("ButtonGroup")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.open)
    ? (_openBlock(), _createBlock(_component_Modal, { key: 0 }, {
        default: _withCtx(() => [
          _createElementVNode("form", {
            onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"])),
            class: "price-tags-modal"
          }, [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _createVNode(_component_TextButton, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('dismiss')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SvgIcon, {
                    type: "mdi",
                    path: _ctx.closeIcon
                  }, null, 8, ["path"])
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_ValidationFormErrors, {
              errors: _ctx.form.errors
            }, null, 8, ["errors"]),
            _createElementVNode("p", null, " Dette vil skrive ut " + _toDisplayString(_ctx.numberOfTags.toLocaleString("nb")) + " prislapper ", 1),
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_ButtonGroup, {
                class: "button-group",
                id: "printPriceTags",
                color: "secondary",
                "value-prop": "value",
                options: _ctx.sizeOptions,
                modelValue: _ctx.form.size,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.size) = $event))
              }, {
                default: _withCtx(({ option }) => [
                  _createTextVNode(_toDisplayString(option.label), 1)
                ]),
                _: 1
              }, 8, ["options", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_ButtonGroup, {
                class: "button-group",
                id: "printPriceTagsPrice",
                color: "secondary",
                "value-prop": "value",
                options: _ctx.priceOptions,
                modelValue: _ctx.form.priceType,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.priceType) = $event))
              }, {
                default: _withCtx(({ option }) => [
                  _createTextVNode(_toDisplayString(option.label), 1)
                ]),
                _: 1
              }, 8, ["options", "modelValue"])
            ]),
            (_ctx.customTextVisible)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _hoisted_8,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.customText) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.form.customText]
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_Button, {
                type: "submit",
                color: "green"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SvgIcon, {
                    type: "mdi",
                    path: _ctx.printIcon
                  }, null, 8, ["path"]),
                  _createTextVNode(" Skriv ut")
                ]),
                _: 1
              }),
              _createVNode(_component_Button, {
                color: "gray",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('dismiss')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Avbryt")
                ]),
                _: 1
              })
            ])
          ], 32)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}